import React, { Component } from 'react';
import { connect } from "react-redux";
import * as actionCreator from "../../../../action/index.js";
class DoorColor extends Component {
  render() {

    return <div className="colors-section-wrapper door-colors section-seprator">

<div className='row align-items-center mb-3'>
                  <div className='col-6'>
                   <h5 className="section-title no-underline mb-0">Door Color</h5>
                  </div>
                
            </div>
               <div className='color-shadow-box'>
               <div className='row'>
                     <div className='col-12 mb-2'>
                     <div className="colors-section-wrapper-label">
                        <h5 className="mb-0 no-underline">Basic</h5>
                        <label>
                        <span className="color-box-value" style={{ background: this.props.params.g_d_c.replace("0x", "#") }}></span>
                       <span className="color-box-name">({this.props.params.g_d_c_name})</span>
                      </label>
                     </div>
                     </div>

                     <div className='col-12'>
                     <div className="colors-section-wrapper-value">
                        <div className="colors-box-sec">
                           <div className="btn-group btn-group-toggle" data-toggle="buttons">
                           {
                              this.props.const_var.garageDoorColor.map((val, index) => {
                                return (
                                  <label key={index} className={this.props.params.g_d_c == val.hex_value.replace("#", "0x") ? "btn  active " : "btn " } style={{ background: val.hex_value }} onClick={() => this.props.roofColorChange('Door', val)}>
                                    <input type="radio" name="options" value={val.hex_value} id={"doorColor" + index} />
                                  </label>
                                )
                              })
                            }
                           </div>
                        </div>
                     </div>
                     </div>
              
            </div>
               </div>

      <div className='d-none'>
      <div className="price-row mb-3">
        <aside className="price-row-left">
          <div className="col-12">
            <aside className="colors-section-wrapper-label">
              <h5 className="mb-0">Door</h5>
              <label>
                <span className="color-box-value" style={{ background: this.props.params.g_d_c.replace("0x", "#") }}></span>
                <span className="color-box-name">({this.props.params.g_d_c_name})</span>
              </label>
            </aside>
          </div>
        </aside>
      </div>

      <div className="extra-hightlight-box">
        <div className="price-row m-0">
          <aside className="price-row-left">
            <aside className="colors-section-wrapper-value">
              <div className="colors-box-sec">

                <div className="btn-group btn-group-toggle" data-toggle="buttons">
                  {
                    this.props.const_var.garageDoorColor.map((val, index) => {
                      return (
                        <label key={index} className={this.props.params.g_d_c == val.hex_value.replace("#", "0x") ? "btn  active " : "btn " } style={{ background: val.hex_value }} onClick={() => this.props.roofColorChange('Door', val)}>
                          <input type="radio" name="options" value={val.hex_value} id={"doorColor" + index} />
                        </label>
                      )
                    })
                  }

                </div>
              </div>
            </aside>
          </aside>
        </div>

      </div>
      </div>

      
    </div>;
  }
}

const mapStoreToProps = (state) => {
  return state.reducer
}


export default connect(
  mapStoreToProps,
  //mapDispachToProps,
  actionCreator
)(DoorColor);

